import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { HomeCatalogResponse } from '../models/homeCatalogResponse';
import { Catalog } from '../models/catalog';
import { TrainingButtonsSection } from '../models/catalogSection';

const addDefaultDetails = (
  section?: TrainingButtonsSection,
  title = 'Recommended Training by Topic',
  description = 'Our experts have curated the best training for each topic'
) => {
  if (section && section.title) section.title = title;
  if (section && section.description) section.description = description;
  return section;
};

const transformCatalog = (catalog: HomeCatalogResponse) => {
  const featureCarouselSection = catalog.sections.find(section => section._type === 'FeatureCarousel');
  const trainingCompilationsSection = catalog.sections.find(section => section._type === 'Compilations');
  const trainingButtonsSection = addDefaultDetails(
    catalog.sections.find(section => section._type === 'Buttons') as TrainingButtonsSection | undefined
  );
  const viewAllSection = catalog.sections.find(section => section._type === 'ViewAll');
  return {
    id: catalog._id,
    featureCarouselSection: featureCarouselSection,
    compilationsSection: trainingCompilationsSection,
    buttonsSection: trainingButtonsSection,
    viewAllSection: viewAllSection,
  };
};

export function getCatalogHomePage(): Promise<Catalog> {
  return cacheableRequest('/catalog/pages/home').then(({ data }: AxiosResponse<HomeCatalogResponse>) => {
    return transformCatalog(data);
  });
}
